import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Button } from "@/components/ui/button";
import { CaretUpDown, Check } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";

export const IngredientCombobox = ({
  items,
  value,
  onSelect,
  placeholder = "Selecionar...",
  searchPlaceholder = "Digite para filtrar...",
  emptyText = "Nenhum encontrado.",
  testId,
  buttonClassName,
  allowNone = false,
  noneLabel = "Sem vínculo",
}) => {
  const [open, setOpen] = useState(false);
  const selected = items.find((i) => i.id === value);
  return (
    <Popover open={open} onOpenChange={setOpen} modal={true}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className={cn("w-full justify-between font-normal", buttonClassName)}
          data-testid={testId}
        >
          <span className="truncate text-left">{selected ? selected.label : placeholder}</span>
          <CaretUpDown size={14} className="ml-1 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[--radix-popover-trigger-width] min-w-[220px]" align="start">
        <Command>
          <CommandInput placeholder={searchPlaceholder} data-testid={testId ? `${testId}-search` : undefined} />
          <CommandList className="max-h-52">
            <CommandEmpty className="py-4 text-center text-xs text-zinc-500">{emptyText}</CommandEmpty>
            {allowNone && (
              <CommandItem value="__none__" onSelect={() => { onSelect(null); setOpen(false); }} data-testid={testId ? `${testId}-none` : undefined}>
                <Check size={14} className={cn("mr-2 shrink-0", !value ? "opacity-100" : "opacity-0")} />
                {noneLabel}
              </CommandItem>
            )}
            {items.map((item) => (
              <CommandItem
                key={item.id}
                value={`${item.label} ${item.id}`}
                onSelect={() => { onSelect(item.id); setOpen(false); }}
              >
                <Check size={14} className={cn("mr-2 shrink-0", value === item.id ? "opacity-100" : "opacity-0")} />
                <span className="truncate">{item.label}</span>
                {item.estimated && (
                  <span className="ml-auto text-[9px] font-bold text-amber-700 bg-amber-100 px-1 py-0.5 rounded shrink-0">~est.</span>
                )}
              </CommandItem>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};

export const EstimatedPriceBadge = ({ className, testId }) => (
  <span
    className={cn("inline-flex items-center text-[10px] font-bold text-amber-700 bg-amber-100 border border-amber-200 px-1.5 py-0.5 rounded", className)}
    title="Preço estimado pelo SousChef IA — confirme ou ajuste o valor real"
    data-testid={testId}
  >
    ~ Preço estimado
  </span>
);
